import React from 'react';
import ReactDOM from 'react-dom/client';
import './monacoSetup'; // bundle Monaco locally (offline editor) — must run before App
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the offline service worker (precaches the app + Pyodide).
serviceWorkerRegistration.register();

reportWebVitals();
